import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signatureLoading: false,
  signature: null,
};

export const signature = createSlice({
  name: "signature",
  initialState,
  reducers: {
    setSignatureLoading(state, action) {
      return {
        ...state,
        signatureLoading: action?.payload,
      };
    },
    setSignature(state, action) {
      return {
        ...state,
        signature: action?.payload.signature,
      };
    },
    setAllSignature(state, action) {
      return {
        ...state,
        allSignature: action?.payload.signatures,
      };
    },
  },
});

export const { setSignatureLoading, setSignature, setAllSignature } = signature.actions;
export default signature.reducer;
